import { CommunityAdvisorWrapperProps } from 'sly/hubPage/components/HubDynamicContent/SharedComponents/CommunityAdvisorWrapper/CommunityAdvisorWrapper.types';

export default function CommunityAdvisorWrapper({
  children,
}: CommunityAdvisorWrapperProps) {
  return (
    <div
      className='mb-l grid w-full grid-cols-1 grid-rows-[auto] gap-x-m gap-y-m overflow-auto rounded py-xs px-0 pb-0 md:mb-xxl md:overflow-visible lg:w-[64.5rem] lg:grid-cols-3'
      data-tp-id='gen-div-4def7842-42cf-4149-9374-74e2336fbc74'
    >
      {children}
    </div>
  );
}
